import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Para quién es esto?',
  a: 'Dueños de negocio con operación activa que sienten desorden interno.'
}, {
  q: '¿Para quién NO es?',
  a: 'Personas empezando desde cero o buscando soluciones rápidas.'
}, {
  q: '¿Qué pasa en el diagnóstico?',
  a: 'Se analiza tu negocio y se identifican los puntos críticos.'
}, {
  q: '¿Es una llamada de venta?',
  a: 'No. Es una conversación estratégica.'
}, {
  q: '¿Qué tipo de negocios aplican mejor?',
  a: 'Negocios con equipo, operación y cierto nivel de ingresos.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-6 bg-navy" data-id="element-73">
      <div className="max-w-3xl mx-auto" data-id="element-74">
        <FadeIn data-id="element-75">
          <h2 className="text-3xl md:text-5xl font-serif text-center mb-16" data-id="element-76">
            Antes de agendar,{' '}
            <span className="text-gold" data-id="element-77">ten en cuenta esto</span>
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-78">
          {faqs.map((faq, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-79">
              <div className="border border-gold/30 rounded-lg overflow-hidden bg-white/[0.02]" data-id="element-80">
                <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-81">
                  <span className="text-lg font-medium text-white" data-id="element-82">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-gold transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-83" />
                </button>
                <AnimatePresence data-id="element-84">
                  {openIndex === i && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-85">
                      <div className="px-6 pb-5 text-gray-light" data-id="element-86">{faq.a}</div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}